var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddRecipient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6465_1836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.91064 22C3.91064 18.13 7.76064 15 12.5006 15C13.4606 15 14.3906 15.13 15.2606 15.37M12.5006 12C13.8267 12 15.0985 11.4732 16.0362 10.5355C16.9739 9.59785 17.5006 8.32608 17.5006 7C17.5006 5.67392 16.9739 4.40215 16.0362 3.46447C15.0985 2.52678 13.8267 2 12.5006 2C11.1746 2 9.90279 2.52678 8.96511 3.46447C8.02743 4.40215 7.50064 5.67392 7.50064 7C7.50064 8.32608 8.02743 9.59785 8.96511 10.5355C9.90279 11.4732 11.1746 12 12.5006 12Z",
    stroke: "#0061AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9905 17.98H17.0105M18.5005 16.52V19.51M22.5005 18C22.5005 18.32 22.4605 18.63 22.3805 18.93C22.2905 19.33 22.1305 19.72 21.9205 20.06C21.568 20.6525 21.0672 21.143 20.4675 21.4831C19.8679 21.8233 19.1899 22.0014 18.5005 22C17.5159 22.0029 16.5664 21.6352 15.8405 20.97C15.5405 20.71 15.2805 20.4 15.0805 20.06C14.6998 19.4404 14.499 18.7272 14.5005 18C14.4998 17.4745 14.6029 16.9541 14.8036 16.4685C15.0044 15.9829 15.299 15.5417 15.6706 15.1701C16.0422 14.7985 16.4834 14.5039 16.969 14.3031C17.4546 14.1024 17.975 13.9993 18.5005 14C19.6805 14 20.7505 14.51 21.4705 15.33C22.1105 16.04 22.5005 16.98 22.5005 18Z",
    stroke: "#0061AF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6465_1836"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.500488)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddRecipient);
export default __webpack_public_path__ + "static/media/add_recipient.55bbc3dd7dbc2d3e14357cd3ca094f96.svg";
export { ForwardRef as ReactComponent };